import { useState } from 'react';
import {
  Panel,
  PanelHeader,
  Group,
  Button,
  Title,
  Text,
  Progress,
} from '@vkontakte/vkui';
import { FlowPreviewBanner } from '../components/FlowPreviewBanner';

const SLIDES = [
  {
    title: 'Добро пожаловать',
    body: 'Добро пожаловать в приложение чемпионата по пилотированию дронов «Пилоты Будущего».',
  },
  {
    title: 'Что ты получишь',
    body: 'Бесплатный доступ к симулятору, обучение и шанс попасть в финал чемпионата.',
  },
  {
    title: 'Как участвовать',
    body: 'Зарегистрируйся на сайте чемпионата «Пилоты будущего», пройди тест и войди по ID Первых и email.',
  },
];

export function OnboardingPage({
  onComplete,
  previewMode,
  onExitPreview,
}: {
  onComplete: () => void | Promise<void>;
  previewMode?: boolean;
  onExitPreview?: () => void;
}) {
  const [step, setStep] = useState(0);
  const slide = SLIDES[step];

  const finish = () => void Promise.resolve(onComplete());

  return (
    <Panel id="onboarding">
      <PanelHeader
        before={
          onExitPreview ? (
            <Button mode="tertiary" onClick={onExitPreview}>
              Выйти
            </Button>
          ) : undefined
        }
      >
        Пилоты Будущего
      </PanelHeader>
      {previewMode && (
        <Group style={{ margin: '0 16px' }}>
          <FlowPreviewBanner />
        </Group>
      )}
      <Group className="pb-glow-card" style={{ margin: 16 }}>
        <div style={{ padding: 16, textAlign: 'center' }}>
          <Title level="2" className="pb-hero-title">
            {slide.title}
          </Title>
          <Text className="pb-body-text" style={{ marginTop: 12, color: 'var(--pb-text-secondary)' }}>
            {slide.body}
          </Text>
          <Progress
            value={(step + 1) / SLIDES.length}
            style={{ marginTop: 24 }}
          />
          <div style={{ display: 'flex', gap: 8, marginTop: 24 }}>
            {step > 0 && (
              <Button
                size="l"
                stretched
                mode="secondary"
                onClick={() => setStep(step - 1)}
              >
                Назад
              </Button>
            )}
            {step < SLIDES.length - 1 ? (
              <Button
                size="l"
                stretched
                className="pb-gradient-btn"
                onClick={() => setStep(step + 1)}
              >
                Дальше
              </Button>
            ) : (
              <Button
                size="l"
                stretched
                className="pb-gradient-btn"
                onClick={finish}
              >
                Понятно
              </Button>
            )}
          </div>
        </div>
      </Group>
    </Panel>
  );
}
